// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.notui.one"
    : "http://localhost:5000";

class DataService {
  constructor() {
    this.baseUrl = API_BASE_URL;
  }

  async getAuthHeaders() {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      throw new Error("No authentication token found");
    }
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
  }

  // Notes API
  async getNotes() {
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${this.baseUrl}/api/notes`, {
      headers,
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to fetch notes");
    }
    return response.json();
  }

  async createNote(note) {
    try {
      console.log("Creating note with data:", note); // Debug log
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${this.baseUrl}/api/notes`, {
        method: "POST",
        headers,
        body: JSON.stringify(note),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || "Failed to create note");
      }

      const createdNote = await response.json();
      console.log("Created note:", createdNote); // Debug log
      return createdNote;
    } catch (error) {
      console.error("Note creation error:", error);
      throw error;
    }
  }

  async updateNote(id, note) {
    try {
      console.log("Updating note:", { id, note }); // Debug log
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${this.baseUrl}/api/notes/${id}`, {
        method: "PATCH", // Changed from PUT to PATCH
        headers,
        body: JSON.stringify(note),
      });

      if (!response.ok) {
        const error = await response.json();
        console.error("Server error:", error); // Log server error
        throw new Error(error.message || "Failed to update note");
      }

      const updatedNote = await response.json();
      console.log("Note updated successfully:", updatedNote); // Debug log
      return updatedNote;
    } catch (error) {
      console.error("Note update error:", error);
      throw error;
    }
  }

  async deleteNote(id) {
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${this.baseUrl}/api/notes/${id}`, {
      method: "DELETE",
      headers,
    });
    if (!response.ok) throw new Error("Failed to delete note");
    return response.json();
  }

  // Tests API
  async getTests() {
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${this.baseUrl}/api/tests`, {
      headers,
    });
    if (!response.ok) throw new Error("Failed to fetch tests");
    return response.json();
  }

  async getTestResults() {
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${this.baseUrl}/api/test-results`, {
      headers,
    });
    if (!response.ok) throw new Error("Failed to fetch test results");
    return response.json();
  }

  // AI Chat
  async chat(messages, noteTitle, noteContent) {
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${this.baseUrl}/api/ai/chat`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        messages,
        noteTitle,
        noteContent,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to get AI response");
    }

    return response.json();
  }

  async createTest(testData) {
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${this.baseUrl}/api/tests`, {
      method: "POST",
      headers,
      body: JSON.stringify(testData),
    });
    if (!response.ok) throw new Error("Failed to create test");
    return response.json();
  }

  async deleteTest(id) {
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${this.baseUrl}/api/tests/${id}`, {
      method: "DELETE",
      headers,
    });
    if (!response.ok) throw new Error("Failed to delete test");
    return response.json();
  }

  async submitTestResult(testId, result) {
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${this.baseUrl}/api/test-results`, {
      method: "POST",
      headers,
      body: JSON.stringify({ testId, ...result }),
    });
    if (!response.ok) throw new Error("Failed to submit test result");
    return response.json();
  }

  async updateTestAttempt(testId) {
    const headers = await this.getAuthHeaders();
    const response = await fetch(
      `${this.baseUrl}/api/tests/${testId}/attempt`,
      {
        method: "PATCH",
        headers,
      }
    );
    if (!response.ok) throw new Error("Failed to update test attempt");
    return response.json();
  }
}

export const dataService = new DataService();
